import {Input} from "reactstrap";
import React from "react";
import "../scss/sfxRoundedButton.css"

export default class SFXRoundedButton extends React.Component {
    render() {
        return <Input
            {...this.props}
            style={{
                ...this.props.style
            }}
            type={"button"}
            onClick={this.props.onClick}
            disabled={this.props.disabled}
            className={"sfx-rounded-btn"}
        />
    }
}
